import { PageLoadStartedEvent } from '../page-load-started-event';
import { PageLoadStartedAttributes, PageLoadStartedCompletePageObject } from '../page-load-started-event/typeDefinitions';
import { getCurrentDate, getCurrentTime } from '../utils';
import { PageLoadStartedInfo } from './typeDefinitions';

export class WindowLoadStartedEvent {
  public event = 'page load started' as const;
  public pageInstanceID: 'dev' | 'stage' | 'prod';
  public page          : PageLoadStartedCompletePageObject;

  constructor(pageInfo: ((info: PageLoadStartedCompletePageObject['info']) => PageLoadStartedCompletePageObject['info']) | PageLoadStartedInfo, pageAttributes: PageLoadStartedAttributes = {}) {
    const existingPageLoadedEvent = window.adobeDataLayer.find(adobeDataLayerEntry => adobeDataLayerEntry.event === 'page load started') as PageLoadStartedEvent;
    this.pageInstanceID = existingPageLoadedEvent.pageInstanceID;

    const existingPageLoadedObject = existingPageLoadedEvent.page;
    const info = pageInfo instanceof Function
      ? pageInfo({ ...existingPageLoadedObject.info })
      : {
        ...existingPageLoadedObject.info,
        ...(pageInfo as PageLoadStartedInfo)
      };

    this.page = {
      info,
      attributes: {
        ...existingPageLoadedObject.attributes,
        ...pageAttributes,
        time: getCurrentTime(),
        date: getCurrentDate()
      }
    };
  }
}